import {
  DynamicDataList,
  type DynamicListColumn,
  GenericField,
  type Nullable,
} from '@axinom/mosaic-ui';
import { useFormikContext } from 'formik';
import React, { useState } from 'react';
import type { UserRoleAssignment } from './RoleSelectionExplorer';
import { useUserRoleSelectFieldDataEntry } from './UserRoleSelectFieldDataEntry';

type FormData = Nullable<{
  name?: string;
  description?: string;
  tags: string[];
  userRoles: UserRoleAssignment[];
}>;

interface UserRoleSelectFieldProps {
  environmentId: string;
  tagsOptions: string[];
  initialRoles: UserRoleAssignment[];
  label: string;
}

export const UserRoleSelectField: React.FC<UserRoleSelectFieldProps> = ({
  environmentId,
  initialRoles,
  label,
}) => {
  const { values, setFieldValue } = useFormikContext<FormData>();
  const [userRoleColumns] = useState<DynamicListColumn<UserRoleAssignment>[]>([
    {
      propertyName: 'name',
      label: 'Name',
      size: '200px',
    },
    {
      propertyName: 'description',
      label: 'Description',
      size: '1fr',
    },
  ]);

  const { UserRoleSelectFieldDataEntry } = useUserRoleSelectFieldDataEntry({
    environmentId,
    currentRoles: values?.userRoles ?? [],
    initialRoles,
  });

  return (
    <>
      <GenericField label={label} name="userRoles">
        <DynamicDataList<UserRoleAssignment>
          value={values.userRoles ?? []}
          columns={userRoleColumns}
          onChange={(newRoles) => {
            const sortedRoles = newRoles.sort((a, b) => {
              return a.name > b.name ? 1 : -1;
            });
            setFieldValue('userRoles', sortedRoles);
          }}
          allowReordering={false}
          allowRowDragging={false}
          showHeader={true}
          allowNewData={true}
          customDataEntry={UserRoleSelectFieldDataEntry}
        />
      </GenericField>
    </>
  );
};
